import React from "react";
import {Col, Row} from "react-bootstrap";
import Loader from "../Loader/Loader";
import {Shadow, WerfenColorMid, White} from "../../Constants/ColorChart";

const LoginLoaderRetrieving: React.FC = () => {
    return (
        <Row>
            <Col lg={{span: 2, offset: 5}} xs={{span: 10, offset: 1}}>
                <Loader
                    message="Retrieving Credentials"
                    primaryColor={WerfenColorMid}
                    secondaryColor={Shadow} fontColor={White}
                />
            </Col>
        </Row>
    );
}

export default LoginLoaderRetrieving;